import { OneWorldSyncLoaderInfoProps } from 'types/OneWorldSyncLoaderTypes';

const loadOneWorldSync = async (props: OneWorldSyncLoaderInfoProps) => {
  const { brand, option, mpn, ean, window } = props;
  if (window && window.ccs_cc_args) {
    return;
  }
  window.ccs_cc_args = window.ccs_cc_args || [];
  window.ccs_cc_args.push(['cpn', `${option}`]);
  window.ccs_cc_args.push(['mf', `${brand ?? brand}`]);
  window.ccs_cc_args.push(['pn', `${mpn}`]);
  window.ccs_cc_args.push(['upcean', `${ean}`]);
  window.ccs_cc_args.push(['ccid', '']);
  window.ccs_cc_args.push(['lang', 'en']);
  window.ccs_cc_args.push(['market', 'GB']);
  window.ccs_cc_args.push(['_Skey', '38acc2d4']);
  window.ccs_cc_args.push(['_ZoneId', 'bf657a4810']);

  const scriptTag: HTMLScriptElement = document.createElement('script');
  scriptTag.type = 'text/javascript';
  scriptTag.async = true;
  scriptTag.src = 'https://cdn.cs.1worldsync.com/jsc/h1ws.js';
  const rootScriptNode: HTMLScriptElement = document.getElementsByTagName('script')[0];
  if (rootScriptNode.parentNode) {
    rootScriptNode.parentNode.insertBefore(scriptTag, rootScriptNode);
  }
};

export default loadOneWorldSync;
